import { CSSProperties } from 'react';
import { Input } from 'antd';

interface Props {
  value: string;
  onChange: (value: string) => void;
  style?: CSSProperties;
}

export const parseProductIdSearchValue = (value: string) => {
  return value
    .split(/\r?\n/)
    .map((item) => item.trim())
    .filter((item) => /^\d+$/.test(item))
    .map(Number);
};

export const getNextAppliedProductId = ({
  appliedValue,
  draftValue,
}: {
  appliedValue: string;
  draftValue: string;
}) => {
  return appliedValue === draftValue ? appliedValue : draftValue;
};

const ProductIdSearch = ({ value, onChange, style }: Props) => {
  return (
    <Input.TextArea
      value={value}
      onChange={(e) => {
        onChange(e.target.value);
      }}
      autoSize={{ minRows: 3, maxRows: 6 }}
      style={style}
    />
  );
};

export default ProductIdSearch;
